import { Component, Input, OnChanges } from "@angular/core";
import { MessageService } from "src/services/message/message.service";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validators,
} from "@angular/forms";
import { AuthService } from "src/services/auth/auth.service";
import { MenuController } from "@ionic/angular";
import { NavigationService } from "src/services/navigation/navigation.service";
import { ActivatedRoute } from "@angular/router";
import { UserApiService } from "src/services/user/user-api.service";
import { passwordFormField } from "./password.form";
import { getPasswordError } from "../form-errors.const";
import { passwordConfirmationValidator } from "src/services/utils/form.validators";
import { BaseFormObjectComponent } from "../base-form-object.component";

type PasswordMode = "login" | "register";

export type EmailPassword = {
  confirmPassword?: string;
  email: string;
  password: string;
};

@Component({
  selector: "rc-password-form-field",
  templateUrl: "./password-form-field.component.html",
  styleUrls: ["./password-form-field.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: PasswordFormFieldComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: PasswordFormFieldComponent,
    },
  ],
  standalone: false,
})
export class PasswordFormFieldComponent extends BaseFormObjectComponent<EmailPassword> implements OnChanges {
  @Input() public emailReadOnly: boolean = false;
  @Input() public mode: PasswordMode;
  @Input() public userId: string | undefined;

  public form: FormGroup = this.formBuilder.group({
    [passwordFormField.email]: new FormControl(
      null,
      Validators.compose([
        (control: AbstractControl) => Validators.required(control),
        (control: AbstractControl) => Validators.email(control),
      ]),
    ),
    [passwordFormField.password]: new FormControl(
      null,
      Validators.compose([(control: AbstractControl) => Validators.required(control), Validators.minLength(8)]),
    ),
    [passwordFormField.confirmPassword]: new FormControl(null),
  });
  public showPassword: boolean = false;
  public passwordInputType: string = "password";

  constructor(
    public readonly navigationService: NavigationService,
    protected readonly activatedRoute: ActivatedRoute,
    protected readonly authService: AuthService,
    protected readonly menu: MenuController,
    protected readonly messageService: MessageService,
    protected readonly userService: UserApiService,
    private readonly formBuilder: FormBuilder,
  ) {
    super();
  }

  async ngOnChanges() {
    if (this.mode === "register") {
      this.form.controls[passwordFormField.confirmPassword].validator = Validators.compose([
        (control: AbstractControl) => Validators.required(control),
        (control: AbstractControl) =>
          passwordConfirmationValidator(control, this.form.controls[passwordFormField.password].value),
      ]);
    }
  }

  public toggleShowPassword(): void {
    this.showPassword = !this.showPassword;
    if (this.showPassword) {
      this.passwordInputType = "text";
    } else {
      this.passwordInputType = "password";
    }
  }

  protected toDisplayValue(_input: EmailPassword): string {
    return "";
  }

  public validate(): object | null {
    if (this.form.valid) {
      return null;
    }

    return this.getAllFormErrors();
  }

  public readonly getPasswordError = getPasswordError;
  public readonly passwordFormField = passwordFormField;
}
